import React, {useContext, useEffect, useMemo, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {Avatar, Box, Button, Chip, Grid, InputAdornment, TextField, Typography} from "@mui/material";

import share from "../../../assets/images/share.svg";
import camera from "../../../assets/images/camera.svg";
import arrowRight from "../../../assets/images/arrowRight.svg";
import profileImg from "../../../assets/images/profileImg.svg";
import snowflake from "../../../assets/images/snowflake.svg";
import updownArrow from "../../../assets/images/updownArrow.svg";
import picture from "../../../assets/images/picture.svg";
import thumb from "../../../assets/images/thumb.svg";
import checkCircle from "../../../assets/images/checkCircle.svg";
import {CopyIcon, FacebookIcon, InstagramIcon, PinterestIcon, TelegramIcon, TwitterIcon} from "../../../assets/svgFile";
import "./myAccount.css";
import moment from "moment";
import {useVarAuth} from "../../../graphql/graphql/auth/defaults";
import {useProfile, useUpdateProfileData} from "../../../graphql/graphql/profile/hooks";
import {TradingFrequencyOptions, TradingYearOptions} from "../profile/profile";
import LoadingWall from "../../../components/loadingWall";
import ShareLinks from "../../dashboard/refLink/shareLinks";
import {MenuContext} from "../../../contexts/menuContext";
import {toast} from "react-toastify";
import EditableInput from "../../../components/editableText";

const tradeCards = [
  {
    icon: <img src={updownArrow} alt="updownArrow" className="tradeIcon" />,
    title: "trades",
    amt: "581",
    chip: "",
  },
  {
    icon: <img src={checkCircle} alt="checkCircle" className="tradeIcon" />,
    title: "wins",
    amt: "89%",
    chip: "SUPERB",
  },
  {
    icon: <img src={picture} alt="upload" className="tradeIcon" />,
    title: "charts posted",
    amt: "1,536",
    chip: "",
  },
  {
    icon: <img src={thumb} alt="thumb" className="tradeIcon" />,
    title: "likes",
    amt: "123K",
    chip: "",
  },
];

const socialIcons = [
  {href: "", icon: <CopyIcon />},
  {href: "", icon: <TwitterIcon />},
  {href: "", icon: <TelegramIcon />},
  {href: "", icon: <FacebookIcon />},
  {href: "", icon: <PinterestIcon />},
  {href: "", icon: <InstagramIcon />},
];

const MyAccount = () => {
  const {user = {}} = useVarAuth();
  const {data, loading} = useProfile();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const {updateProfile, loading: updateLoading} = useUpdateProfileData();
  const {open, isSmall} = useContext(MenuContext);
  //console.log(isSmall);
  const acDetail = useMemo(
    () => [
      {title: "name", detail: data?.name},
      {
        name: "email",
        title: "email",
        detail: !show ? "******@" + data?.email.split("@")[1] : data?.email,
        label: (
          <Button variant="text" sx={{color: "#0972D3"}} className="!capitalize" onClick={() => setShow(!show)}>
            {show ? "Hide" : "Reveal"}
          </Button>
        ),
        noEdit: true,
      },
      {
        name: "phone",
        title: "phone number",
        detail: data?.phone,
      },
    ],
    [show, data]
  );

  if (loading) return <LoadingWall />;
  return (
    <Box className="accountMain">
      <Typography variant="h4" className="setting_page_heading mb_0">
        My Account
      </Typography>
      <Box className="accountProfile">
        <Box className="bgBlank"></Box>
        <Box className="profileDetail">
          <Box
            className="profileBox"
            sx={{display: "flex", mt: 3}}
            flexWrap="wrap"
            alignItems="flex-start"
            justifyContent="space-between"
          >
            <Box className="profileSect" sx={{display: "flex", gap: "24px"}}>
              <Box className="profileImg">
                <img src={user.avatar || profileImg} alt="profile" className="avtarImg" />
              </Box>
              <Box className="acId">
                <Typography variant="h5" display="flex" sx={{fontSize: "24px"}} alignItems="center">
                  {user.name} <img src={camera} alt="camera" />
                  <img src={share} alt="share" />
                </Typography>
                <Typography className="acSubtitle" variant="subtitle1">
                  {TradingFrequencyOptions.find(({value}) => value == data?.tradingFrequency)?.title}
                </Typography>
              </Box>
            </Box>
            {!isSmall && (
              <Button>
                <img src={arrowRight} alt="arrow" />
                Share & Earn
              </Button>
            )} 
          </Box>
          <Box className="editSect" mt={4} gap="20px">
            <Box flex="1">
              <Typography>APP Member since</Typography>
              <Typography variant="h6">{moment(user.createdAt).format("MMM DD, YYYY")}</Typography>
            </Box>
            <Box flex="1">
              <Typography>trading since</Typography>
              <Box sx={{display: "flex"}} justifyContent="space-between">
                <Typography variant="h6" onClick={isSmall ? () => navigate("/settings/profile") : undefined}>
                  {data?.tradingSince
                    ? TradingYearOptions.find(({value}) => value == data?.tradingSince)?.title
                    : "Add years"}
                </Typography>
                {!isSmall && (
                  <Button className="btnEdit" onClick={() => navigate("/settings/profile")}>
                    {data?.tradingSince ? "Edit" : "Add"}
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="shareSect">
        <Typography variant="h6">TRADE WITH YOUR FRIENDS</Typography>
        <Typography>
          Hang out with your friends in the buythedip.com community. Achieving financial freedom is a challenge, but when you get there you'll want 
          familiar faces around you. Anyone is welcome to come learn, trade, and reap the benefits of the market with us. Share your link 
          now and if they sign up, you'll automatically become an affiliate partner.
        </Typography>
        <ShareLinks type={"vertical"} />
      </Box>
      <Box className="accountSect" pt={4} mb={3}>
        <Typography variant="h5">My Account</Typography>
        {acDetail.map((ac, key) => (
          <EditableInput
            {...ac}
            onSave={updateProfile}
            loading={updateLoading}
            onSuccessMessage="Profile updated successfully"
            key={key}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MyAccount;
